import { Outlet } from '@tanstack/react-router'
import { AppLayout } from '@/shared/components/AppLayout'

/**
 * Root layout for all authenticated routes.
 * Uses AppLayout which switches between BottomNav (mobile) and SideNav (tablet+).
 * <main tabIndex={-1}> allows RouterFocusManager to advance focus here on route change.
 */
export function AuthenticatedLayout() {
  return (
    <div className="min-h-screen bg-canvas">
      <AppLayout>
        <Outlet />
      </AppLayout>
    </div>
  )
}
